export function FormOptionalSectionDivider() {
  return (
    <div className="flex items-center gap-3">
      <div className="h-px flex-1 bg-border" />
      <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        Optional
      </span>
      <div className="h-px flex-1 bg-border" />
    </div>
  );
}
